var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('views/textingTipsEmbeds.js', function (require) {
    var _data = require('../data');

    var _data2 = _interopRequireDefault(_data);

    Flint.staticStyles('TextingTipsEmbeds', {
      '$': '#_flintapp .ViewTextingTipsEmbeds',
      '$ttEmbed': '#_flintapp ttEmbed.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.ttEmbed, #_flintapp .ViewTextingTipsEmbeds.ttEmbed, #_flintapp .TextingTipsEmbeds > .ttEmbed',
      '$previewSec': '#_flintapp previewSec.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.previewSec, #_flintapp .ViewTextingTipsEmbeds.previewSec, #_flintapp .TextingTipsEmbeds > .previewSec',
      '$postTitle': '#_flintapp postTitle.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.postTitle, #_flintapp .ViewTextingTipsEmbeds.postTitle, #_flintapp .TextingTipsEmbeds > .postTitle',
      '$timestamp': '#_flintapp timestamp.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.timestamp, #_flintapp .ViewTextingTipsEmbeds.timestamp, #_flintapp .TextingTipsEmbeds > .timestamp'
    }, {
      '$': {
        flexDirection: 'row',
        flexGrow: 1,
        flexWrap: 'wrap',
        justifyContent: 'space-between'
      },
      '$ttEmbed': {},
      '$previewSec': {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        borderRadius: 4
      },
      '$postTitle': {
        textAlign: 'center',
        color: 'white',

        marginTop: 4,
        fontWeight: 'bold'
      },
      '$timestamp': {
        fontSize: 10,
        color: '#ccc',
        alignSelf: 'flex-end',
        marginRight: 4,
        marginBottom: 2
      }
    });
    Flint.view('TextingTipsEmbeds', function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });

      var pro = initPro(view, {
        numPosts: M.defaultAtom(4),
        style: M.mergeAtom({
          width: 400
        })
      });

      var getThumbUrl = function getThumbUrl(post) {
        if (post.thumbUrl.indexOf('/') == 0) {
          return 'https://texting.tips' + post.thumbUrl;
        } else {
          return post.thumbUrl;
        }
      };

      var getExternalUrl = function getExternalUrl(post) {
        if (post.url.indexOf('/') == 0) {
          return 'https://texting.tips' + post.url;
        } else {
          return post.url;
        }
      };

      var spacing = atom(22);

      var embedWidth = derivation(function () {
        if (context.isMobile.get()) {
          return (pro.style.get().get('width') - 3 * spacing.get()) / 2;
        } else {
          return (pro.style.get().get('width') - (pro.numPosts.get() + 1) * spacing.get()) / pro.numPosts.get();
        }
      });
      var embedHeight = embedWidth.derive(function (w) {
        return w * 9 / 16;
      });

      var posts = _data2.default.textingTipsPosts.toJS();view.render(function () {
        return Flint.range(posts.slice(0, pro.numPosts.get())).map(function (_, _index) {
          return view.el(
            ['ttEmbed', 1, _, _index],
            { repeat: posts.slice(0, pro.numPosts.get()) },
            view.el(
              ['timestamp', 1, _, _index],
              null,
              M.util.formatMessengerDate(_.timestamp)
            ),
            view.el(
              ['Link', 1, _, _index],
              { to: getExternalUrl(_), target: '_blank' },
              view.el(['previewSec', 1, _, _index], null)
            ),
            view.el(
              ['captionSec', 1, _, _index],
              null,
              view.el(
                ['Link', 2, _, _index],
                { className: 'postTitle', to: getExternalUrl(_), target: '_blank' },
                _.title
              )
            )
          );
        });
      });

      $["$"] = function (_, _index) {
        return { padding: [spacing.get(), spacing.get(), 0]
        };
      };

      $["ttEmbed"] = function (_, _index) {
        return {
          width: embedWidth.get(),
          marginBottom: spacing.get()
        };
      };

      '84a94a6a';

      $["previewSec"] = function (_, _index) {
        return {
          width: embedWidth.get(),
          height: embedHeight.get(),
          backgroundImage: 'url(' + getThumbUrl(_) + ')' };
      };

      '01e262f7';

      $["postTitle"] = function (_, _index) {
        return { fontSize: context.isMobile.get() ? 11 : 12 };
      };

      '7e69ff88';
    });
  })
})();
//# sourceMappingURL=textingTipsEmbeds.js.map
